/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function ArrowDashIcon(props: IProps) {
  const { width = 68, height = 15, ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 68 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M0 13.9706H68" stroke="#9193AA" strokeOpacity="0.5" strokeDasharray="2 2" />
      <path
        d="M46.7122 4.32413C46.9075 4.12887 46.9075 3.81229 46.7122 3.61703L43.5303 0.435047C43.335 0.239785 43.0184 0.239785 42.8232 0.435047C42.6279 0.630309 42.6279 0.946892 42.8232 1.14215L45.6516 3.97058L42.8232 6.79901C42.6279 6.99427 42.6279 7.31085 42.8232 7.50611C43.0184 7.70138 43.335 7.70138 43.5303 7.50611L46.7122 4.32413ZM18.1333 3.97058V4.47058H46.3587V3.97058V3.47058H18.1333V3.97058Z"
        fill="#9193AA"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export default ArrowDashIcon;
